import { dm_trang_thai_lead } from "../../../models/response/category/dm_trang_thai_lead";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const objDmTrangThaiLeadDefine = {
    LOAD_START: 0,
    LOAD_SUCCESS: [] as dm_trang_thai_lead[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as dm_trang_thai_lead | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as dm_trang_thai_lead,
    SAVE_SUCESS: {} as dm_trang_thai_lead,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eDmTrangThaiLeadActionTypeIds = generateActionTypeIds(objDmTrangThaiLeadDefine, "DM_TRANG_THAI_LEAD")
export type IDmTrangThaiLeadActionTypes = IGenericActionType<typeof objDmTrangThaiLeadDefine, "DM_TRANG_THAI_LEAD">
